var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{attrs:{"id":"map"}},[_c('GmapMap',{staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.props.data.center,"zoom":15}},[_c('GmapMarker',{attrs:{"position":_vm.props.data.center,"draggable":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }